import { render } from "./InfoCiclo.vue?vue&type=template&id=0216335c&scoped=true"
import script from "./InfoCiclo.vue?vue&type=script&lang=js"
export * from "./InfoCiclo.vue?vue&type=script&lang=js"

import "./InfoCiclo.vue?vue&type=style&index=0&id=0216335c&lang=css"
import "./InfoCiclo.vue?vue&type=style&index=1&id=0216335c&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0216335c"]])

export default __exports__